export const GUN_LIST_CONTACT_DETAILS_STEP_ID = 'gun-list-contact-details';
export const GUN_LIST_CERTIFICATIONS_STEP_ID = 'gun-list-certifiactions';
export const GUN_LIST_EXCEPTIONS_STEP_ID = 'gun-list-exceptions';
